import {
	addDays,
	formatCalendarDate,
	formatInstant,
	isValidCalendarDate,
	toCompact,
	unixToDate,
} from '@lib/datetime'

/** `YYYYMMDD` (date-only) → "MMM D, YYYY", or a dash placeholder when unset/invalid. */
export const formatDateOnly = (yyyymmdd: string | null): string =>
	formatCalendarDate(yyyymmdd, 'medium') || '—'

/** Unix seconds → "MMM D, YYYY" in the viewer's timezone. */
export const formatDate = (unixSeconds: number): string =>
	formatInstant(unixToDate(unixSeconds), 'dateMedium')

/** Unix seconds → "MMM D, YYYY, h:mm AM/PM" in the viewer's timezone. */
export const formatDateTime = (unixSeconds: number): string =>
	formatInstant(unixToDate(unixSeconds), 'datetimeWithYear')

/**
 * A trip's date span: `startDate` (`YYYYMMDD`) through `startDate + dayCount - 1`.
 * Returns the start alone for 0/1-day trips, or "—" when no start is set.
 */
export const formatTripDates = (startDate: string | null, dayCount: number): string => {
	if (!isValidCalendarDate(startDate)) return '—'
	const start = formatCalendarDate(startDate, 'medium')
	if (dayCount <= 1) return start
	const end = toCompact(addDays(startDate, dayCount - 1))
	return `${start} – ${formatCalendarDate(end, 'medium')}`
}

/** "First Last", trimmed; falls back to a dash when both names are empty. */
export const formatName = (firstName: string, lastName: string): string =>
	`${firstName} ${lastName}`.trim() || '—'
